
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 138 92"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h138v92H0z"}}),_c('path',{attrs:{"d":"M0 0h138v36H0z"}}),_c('g',{attrs:{"transform":"translate(69 36)"}},[_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"id":"a","d":"M-30 0L0-5.742V5.742z","fill":"#fcd116"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(22.5)"}}),_c('use',{attrs:{"xlink:href":"#a","transform":"rotate(45)"}})]),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(67.5)"}}),_c('use',{attrs:{"xlink:href":"#b","transform":"rotate(135)"}})]),_c('path',{attrs:{"fill":"#0072c6","d":"M0 36h138v20H0z"}}),_c('path',{attrs:{"d":"M0 0v92h68M138 0v92H68","fill":"#ce1126"}})])
          )
        }
      }
    